import { IOsiCorrectionFormViewModel } from '@shared/types/mobx/entities/osiCorrections';
import { injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';
import { Abonent } from '@shared/types/osi/abonents';
import logger from 'js-logger';
import { notifications } from '@shared/utils/notifications';
import { AreaTypeCodes } from '@shared/types/dictionaries';

const ADDITIONAL_SERVICE_GROUP_ID_LEGACY = 7;

@injectable()
export class OsiCorrectionFormViewModel implements IOsiCorrectionFormViewModel {
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  private _abonents: Abonent[] = [];

  set abonents(value: Abonent[]) {
    this._abonents = value;
  }

  private _onSubmitCb: any = async () => {};

  set onSubmitCb(value: any) {
    this._onSubmitCb = value;
  }

  private _services: any = [];

  get services(): any {
    return this._services;
  }

  set services(value: any) {
    this._services = value;
  }

  getAbonents = (serviceGroupId: number): Abonent[] => {
    // Миграция: external удалён из БД; арендатор определяется по areaTypeCode
    if (serviceGroupId === ADDITIONAL_SERVICE_GROUP_ID_LEGACY) {
      return this._abonents?.filter((abonent: any) => abonent.areaTypeCode === AreaTypeCodes.ARENDATOR);
    }

    // Фикс арендаторов: для обычных категорий арендаторы больше НЕ исключаются —
    // корректировки доступны им так же, как остальным типам помещений.
    return this._abonents;
  };

  onSubmit = async (values: any): Promise<void> => {
    try {
      this.isLoading = true;

      await this._onSubmitCb?.(values);
    } catch (e) {
      logger.error(e);
      notifications.error();
    } finally {
      this.isLoading = false;
    }
  };
}
